<template>
  <!--
          作者：luoyiming
          时间：2019-10-24
          描述：登录页面
      -->
  <div class="login-bg fx-center al-center" :style="'background-image:url(' + bgimg_url + ');'">
    <div class="continer fx-center al-center">
      <el-image v-if="!isMobile" class="" :src="require('@/assets/img/login_img.png')"></el-image>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-position="left" label-width="0px" class="demo-ruleForm login-container fx-col-center al-center">
        <h3 class="title col-main">后台登录</h3>
        <el-form-item prop="account">
          <div class="left-img-input">
            <img class="l-img" src="../assets/img/login-name.png" />
            <el-input class="l-input" type="text" v-model="ruleForm.account" auto-complete="off" placeholder="请输入账号"></el-input>
          </div>
        </el-form-item>
        <el-form-item prop="checkPass">
          <div class="left-img-input">
            <img class="l-img" src="../assets/img/login-password.png" />
            <el-input class="l-input" type="password" v-model="ruleForm.checkPass" auto-complete="off" placeholder="请输入密码"></el-input>
          </div>
        </el-form-item>
        <el-form-item prop="verifycode" style="line-height:0px;">
          <div class="d-b-c">
            <div class="left-img-input" style="width: auto;">
              <el-input v-model="ruleForm.verifycode" ref="verifycode" placeholder="验证码" class="l-input" style="width:230px;"></el-input>
            </div>
            <div class="identifybox" style=" flex-shrink: 0;" @click="refreshCode">
              <sidentify :identifyCode="identifyCode"></sidentify>
            </div>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button class="login-btn bg-main" @click.native.prevent="SubmitFunc" :loading="logining">登录</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import sidentify from "@/components/sidentify";
import IndexApi from "@/api/index.js";
import bgimg from "@/assets/img/login_bg.png";
import UserApi from "@/api/user.js";
import { setCookie, setSessionStorage } from "@/utils/base.js";
import { mapState } from "vuex";
export default {
  components: {
    sidentify,
  },
  data() {
    // 验证码自定义验证规则
    const validateVerifycode = (rule, value, callback) => {
      if (value === "") {
        this.refreshCode();
        callback(new Error("请输入验证码"));
      } else if (value !== this.identifyCode) {
        console.log("验证码:", value);
        this.refreshCode();
        callback(new Error("验证码不正确!"));
      } else {
        callback();
      }
    };
    return {
      loginForm: {},
      identifyCodes: "1234567890", //验证码的数字库
      identifyCode: "", // 验证码组件传值
      /*是否正在加载*/
      loading: true,
      /*系统名称*/
      supplier_name: "",
      /*背景图片*/
      bgimg_url: "",
      /*是否正在提交*/
      logining: false,
      /*表单对象*/
      ruleForm: {
        /*用户名*/
        account: "",
        /*密码*/
        checkPass: "",
      },
      /*验证规则*/
      rules: {
        /*用户名*/
        account: [{ required: true, message: "请输入用户名", trigger: "blur" }],
        /*密码*/
        checkPass: [{ required: true, message: "请输入密码", trigger: "blur" }],
        verifycode: [
          {
            required: true,
            trigger: "blur",
            validator: validateVerifycode,
          },
        ],
      },
      /*基础配置*/
      baseData: {},
    };
  },
  computed: {
    ...mapState(["isMobile"]),
  },
  created() {
    this.refreshCode();
    this.getData();
  },
  mounted() {
    this.identifyCode = "";
    this.makeCode(this.identifyCodes, 4);
  },
  methods: {
    //验证码----start
    randomNum(min, max) {
      return Math.floor(Math.random() * (max - min) + min);
    },
    refreshCode() {
      this.identifyCode = "";
      this.makeCode(this.identifyCodes, 4);
    },
    makeCode(o, l) {
      for (let i = 0; i < l; i++) {
        this.identifyCode += this.identifyCodes[this.randomNum(0, this.identifyCodes.length)];
      }
      // console.log("this.identifyCode:", this.identifyCode);
    },
    refreshCode() {
      this.identifyCode = "";
      this.makeCode(this.identifyCodes, 4);
    },
    /*获取基础配置*/
    getData() {
      let self = this;
      IndexApi.base(true)
        .then(res => {
          self.loading = false;
          self.baseData = res.data;
          self.supplier_name = res.data.settings.supplier_name;
          if (res.data.settings.supplier_bg_img != "") {
            self.bgimg_url = res.data.settings.supplier_bg_img;
          } else {
            self.bgimg_url = bgimg;
          }
        })
        .catch(error => {
          self.loading = false;
        });
    },

    /*登录方法*/
    SubmitFunc(ev) {
      var _this = this;
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.logining = true;
          var Params = {
            username: this.ruleForm.account,
            password: this.ruleForm.checkPass,
          };
          /*调用登录接口*/
          UserApi.login(Params, true)
            .then(res => {
              this.logining = false;
              if (res.code == 1) {
                /*保存个人信息*/
                setCookie("userinfo_supplier", JSON.stringify(res.data));
                /*设置一个登录状态*/
                setCookie("isLogin_multisupplier", true);
                /*跳转到首页*/
                this.$router.push({ path: "/" });
              } else {
                this.$message({
                  message: "登录失败",
                  type: "error",
                });
              }
            })
            .catch(error => {
              //接口调用方法统一处理
              this.logining = false;
            });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@media screen and (max-width: 768px) {
  .login-bg {
    .continer {
      border-radius: 2.6667vw;
      overflow: hidden;
      box-shadow: 0px 4px 8px 2px rgba(0, 0, 0, 0.04), 0px 2px 6px 0px rgba(0, 0, 0, 0.06), 0px 0px 4px 0px rgba(0, 0, 0, 0.08);
      /deep/ .login-container {
        height: 106.6667vw;
        width: 90.6667vw;
        .title {
          text-align: center;
          font-size: 5.3333vw;
          font-family: Microsoft YaHei;
          font-weight: 400;
          line-height: 5.3333vw;
          margin-bottom: 5.3333vw;
        }

        .left-img-input {
          width: 80vw;
          height: 10.6667vw;
          border: 1px solid #d8d8d8;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          padding: 0 2.6667vw;
          .l-input {
            flex: 1;
            border: none;
            background: none;
            font-size: 1.8667vw;
            color: #666666;
            input {
              border: 0;
            }
          }

          .l-img {
            width: 8vw;
            height: 8vw;
            margin-right: 2.6667vw;
            flex-shrink: 0;
          }

          .el-input__inner {
            border: none;
            padding: 0;
            background: none;
          }
        }
        .d-b-c {
          width: 80vw !important;
          display: flex;
          flex-flow: column nowrap;
          justify-content: flex-start;
          align-items: flex-start;
          .identifybox {
            width: 14.9333vw;
            height: 5.4667vw;
            margin-bottom: 2.6667vw;
          }
          .left-img-input {
            height: 10.6667vw !important;
            width: 100% !important;
            margin-bottom: 2.6667vw;
            .l-input {
              width: 100% !important;
            }
          }
        }
        .login-btn {
          width:80vw;
          height: 10.6667vw;
          font-size: 4.2667vw;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #ffffff;
          text-align: center;
          line-height: 10.6667vw;
          border: none;
          padding: 0 !important;
          &:hover {
            background-color: var(--colMain3);
          }
        }
      }
    }
  }
}
@media screen and (min-width: 769px) {
  .login-bg {
    .continer {
      border-radius: 0.625vw;
      overflow: hidden;
      box-shadow: 0px 4px 8px 2px rgba(0, 0, 0, 0.04), 0px 2px 6px 0px rgba(0, 0, 0, 0.06), 0px 0px 4px 0px rgba(0, 0, 0, 0.08);
      .el-image {
        width: 43.125vw;
        height: 40.2083vw;
      }
      /deep/ .login-container {
        height: 40.2083vw;
        width: 40vw;
        .title {
          text-align: center;
          font-size: 1.8229vw;
          font-family: Microsoft YaHei;
          font-weight: 400;
          line-height: 2.5521vw;
          margin-bottom: 3.6458vw;
        }
        .d-b-c {
          width: 23.3854vw !important;
          display: flex;
          flex-flow: column nowrap;
          justify-content: flex-start;
          align-items: flex-start;
          .identifybox {
            width: 5.8333vw;
            height: 2.1354vw;
            margin-bottom: 1.0417vw;
          }
          .left-img-input {
            height: 2.9688vw !important;
            width: 100% !important;
            margin-bottom: 1.0417vw;
            .l-input {
              width: 100% !important;
            }
          }
        }
        .left-img-input {
          width: 23.3854vw;
          height: 2.9688vw;
          border: 1px solid #d8d8d8;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          padding: 0 0.9375vw;
          .l-input {
            flex: 1;
            border: none;
            background: none;
            font-size: 14px;
            color: #666666;
            input {
              border: 0;
            }
          }

          .l-img {
            width: 1.25vw;
            height: 1.25vw;
            margin-right: 0.5208vw;
            flex-shrink: 0;
          }

          .el-input__inner {
            border: none;
            padding: 0;
            background: none;
          }
        }
        .login-btn {
          width: 23.3854vw;
          height: 2.9167vw;
          font-size: 1.25vw;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #ffffff;
          text-align: center;
          line-height: 2.9167vw;
          border: none;
          padding: 0 !important;
          &:hover {
            background-color: var(--colMain3);
          }
        }
      }
    }
  }
}
.login-bg {
  width: 100%;
  height: 100%;
  background: no-repeat;
  background-size: cover;
  .continer {
    /deep/ .login-container {
      background-clip: padding-box;
      background: #ffffff;
      box-sizing: border-box;
      position: relative;

      .checkbox {
        margin-right: 13px;

        .el-checkbox__inner {
          border-radius: 50%;
          border-color: #5cb85c;
        }

        .el-checkbox__input.is-checked .el-checkbox__inner {
          background-color: #5cb85c;
        }
      }

      .remember {
        margin: 0px 0px 35px 0px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/login.vue